/**
 * Ripple effect using event delegation.
 * Attaches a single listener to `document` and matches clicks against
 * the given CSS selector — so buttons added after mount (lazy sections,
 * modals) automatically get the ripple without re-calling this function.
 *
 * Fixes: offsetLeft was relative to nearest positioned ancestor, not the
 * viewport. getBoundingClientRect() gives the correct viewport position.
 */
export function attachRipple(selector = "button") {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(selector);
    if (!btn) return;

    // Ensure the button is positioned so the absolute ripple child works
    const position = getComputedStyle(btn).position;
    if (position === "static") btn.style.position = "relative";

    const rect = btn.getBoundingClientRect();
    const diameter = Math.max(btn.clientWidth, btn.clientHeight);
    const radius = diameter / 2;

    const circle = document.createElement("span");
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${e.clientX - rect.left - radius}px`;
    circle.style.top = `${e.clientY - rect.top - radius}px`;
    circle.classList.add("ripple");

    // Remove any previous ripple still animating
    const existing = btn.getElementsByClassName("ripple")[0];
    if (existing) existing.remove();

    btn.appendChild(circle);
  });
}
